import React from 'react';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import * as Styled from 'form/styles/FormEditView.style';

interface StringFieldProps {
  slug: string;
  multiline?: boolean;
}

export default function StringField({
  slug,
  multiline,
}: StringFieldProps): JSX.Element {
  const { values, setFieldValue } = useFormikContext<Record<string, any>>();
  const { t } = useTranslation('pageForm');

  if (multiline) {
    return (
      <Styled.Textarea
        id={slug}
        name={slug}
        value={(values[slug] as string) || ''}
        onChange={(e) => setFieldValue(slug, e.target.value)}
        placeholder={t('edit.placeholder')}
      />
    );
  }

  return (
    <Styled.Input
      id={slug}
      name={slug}
      type="text"
      value={(values[slug] as string) || ''}
      onChange={(e) => setFieldValue(slug, e.target.value)}
      placeholder={t('edit.placeholder')}
    />
  );
}
